import request from "../utils/fetch";

// 水卡列表
export function cardList(data) {
  return request({
    url: "/user/card/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 水卡绑定
export function cardBind(data) {
  return request({
    url: "/user/card/bingCard",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//水卡导出
export function cardExport(data) {
  return request({
    url: "/user/card/export",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
    header: {
      headers: { "Content-Type": "application/x-download" },
    },
    responseType: "blob",
  });
}

// 水卡导出查询数量
export function cardExportNum(data) {
  return request({
    url: "/user/card/export/count",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 导表模板下载
export function template(data) {
  return request({
    url: "/user/card/download",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
    header: {
      headers: { "Content-Type": "application/x-download" },
    },
    responseType: "blob",
  });
}

// 导入
export function upload(data) {
  return request({
    url: "/user/card/upload",
    method: "post",
    requestBody: "upload",
    loading: true,
    data: data.file,
  });
}

// 手动开通实物卡
export function cardAdd(data) {
  return request({
    url: "/user/card/add",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 充值模板下载
export function topTemplate(data) {
  return request({
    url: "/order/water/ticket/order/excel",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
    header: {
      headers: { "Content-Type": "application/x-download" },
    },
    responseType: "blob",
  });
}

// 充值套餐下拉
export function menuArr(data) {
  return request({
    url: "/order/water/ticket/package/admin/down",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 批量充值导入
export function topUpload(data) {
  return request({
    url:
      "/order/water/ticket/order/admin/poi/create?payMoney=" +
      data.payMoney +
      "&giveMoney=" +
      data.giveMoney +
      "&packageId=" +
      data.packageId +
      "&payType=" +
      data.payType,
    method: "post",
    requestBody: "upload",
    loading: true,
    data: data.file,
  });
}

// 分配员工
export function moreFen(data) {
  return request({
    url: "/user/card/excel/batch/user?userId=" + data.userId,
    method: "post",
    requestBody: "upload",
    loading: true,
    data: data.file,
  });
}

// 批次号查询充值列表
export function topList(data) {
  return request({
    url: "/order/water/ticket/order/list/by/batch",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 卡号充值-批量
export function cardTopBatch(data) {
  return request({
    url: "/order/water/ticket/order/admin/num/create",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 卡号充值-单个
export function cardTopOne(data) {
  return request({
    url: "/order/water/ticket/order/admin/one/create",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 水卡金额信息
export function cardMoneyInfo(data) {
  return request({
    url: "/order/water/card/get/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 客户水卡详情
export function userInfo(data) {
  return request({
    url: "/user/card/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 挂失/解除挂失
export function report(data) {
  return request({
    url: "/user/card/updateStatus",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
// 企业新增下拉
export function enterpriseListPullNew(data) {
  return request({
    url: "/user/company/pullAddList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
// 补卡
export function reCard(data) {
  return request({
    url: "/user/card/reissueCard",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//转移记录
export function shiftRecord(data) {
  const { pageNum, pageSize, ...restData } = data;
  return request({
    url:
      "/order/water/ticket/order/shift/list?pageNum=" +
      data.pageNum +
      "&pageSize=" +
      data.pageSize,
    method: "post",
    requestBody: "body",
    loading: true,
    data: restData,
  });
}

//迁移
export function transfer(data) {
  return request({
    url: "/order/water/ticket/order/money/shift",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

//水卡删除
export function cardDel(data) {
  return request({
    url: "/order/water/ticket/order/del",
    method: "DELETE",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//水卡下拉
export function cardPull(data) {
  return request({
    url: "/user/card/pullCard",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

export function orderStatistics(data) {
  return request({
    url: "/order/system/statistics/get/all",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

export function codeImg(data) {
  return request({
    url: "/order/water/ticket/order/batch/create/pay",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 黑皮钛列表
export function hptList(data) {
  return request({
    url: "/user/card/happy/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 黑皮钛挂失
export function hptLost(data) {
  return request({
    url: "/user/card/happy/lost",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 管理人员下拉
export function userPull(data) {
  return request({
    url: "/user/afterSales/user/pullList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 分配员工
export function fenStaff(data) {
  return request({
    url: "/user/card/allot/card",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 解绑
export function jiebang(data) {
  return request({
    url: "/user/card/unbind/card",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 解绑和绑卡记录
export function unbindjilu(data) {
  return request({
    url: "/user/card/unbind/cardList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 水卡清零
export function qingling(data) {
  return request({
    url: "/order/water/card/reset/clear/all",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 清零记录
export function qinglingjilu(data) {
  return request({
    url: "/order/water/card/get/detailed/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 项目列表
export function projectList(data) {
  return request({
    url: "/order/water/ticket/receive/enterprise/list",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

// 项目详情
export function projectDetail(data) {
  return request({
    url: "/order/water/ticket/receive/info",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

// 水卡列表全部
export function listAll(data) {
  return request({
    url: "/user/card/all/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 挂失解除挂失

export function guashiAll(data) {
  return request({
    url: "/user/card/lost",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 分配员工

export function fenPeople(data) {
  return request({
    url: "user/card/batch/user",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 接卡编辑
export function jiekabianji(data) {
  return request({
    url: "/order/water/ticket/receive/edit",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 水卡共享用户
export function cardShareList(data) {
  return request({
    url: "/user/card/share/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 查询当前水卡分区内的其他用户水卡
export function queryCard(data) {
  return request({
    url: "/user/card/share/listByUserId",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 余额转移
// export function moneyPass(data) {
//   return request({
//     url: "/order/water/ticket/order/money/some/shift",
//     method: "post",
//     requestBody: "body",
//     loading: true,
//     data: data,
//   });
// }

export function moneyPass(data) {
  return request({
    url: "/order/water/ticket/order/server/money/shift",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 普通实物卡转时效实物卡--导表
export function timeCardupload(data) {
  return request({
    url: "/user/yearCard/export/update",
    method: "post",
    requestBody: "upload",
    loading: true,
    data: data.file,
  });
}

// 普通实物卡转时效实物卡--手写
export function timeCard(data) {
  return request({
    url: "/user/yearCard/entity/update",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 家用机水卡统计
export function waterCardOrderDetailRo(data) {
  return request({
    url: "order-ro/waterCardConsumeDetails/get/water/card/info",
    method: "get",
    requestBody: "query",
    loading: false,
    params: data,
  });
}

// 余额跨服务转移水卡列表
// 售水机
export function waterCardListSsj(data) {
  return request({
    url: "/order/user/water/ticket/wallet/server/get/list",
    method: "get",
    requestBody: "query",
    loading: false,
    params: data,
  });
}

// 厨下
export function waterCardListRo(data) {
  return request({
    url: "/order-ro/user/water/ticket/wallet/server/get/list",
    method: "get",
    requestBody: "query",
    loading: false,
    params: data,
  });
}

// 楼宇机
export function waterCardListLyj(data) {
  return request({
    url: "/order-Lyj/user/water/ticket/wallet/server/get/list",
    method: "get",
    requestBody: "query",
    loading: false,
    params: data,
  });
}

//

// 水卡白名单添加
export function whiteAdd(data) {
  return request({
    url: "/user/card/white/add",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 水卡白名单列表
export function whiteList(data) {
  return request({
    url: "/user/card/white/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 水卡白名单删除
export function whiteDel(data) {
  return request({
    url: "/user/card/white/del",
    method: "DELETE",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 水卡清零流程********************

// 水卡清零审核
export function cardClearZeroCheck(data) {
  return request({
    url: "/order/water/card/reset/check",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

export function cardClearZeroCheckList(data) {
  return request({
    url: "/order/water/card/reset/get/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

export function cardHuiFu(data) {
  return request({
    url: "/order/water/card/reset/restore/clear/all/restore",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}


export function huifulist(data) {
  return request({
    url: "/order/water/card/reset/restore/clear/all/restore/list?pageNum=" +
      data.pageNum +
      "&pageSize=" +
      data.pageSize,
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}



export function cardqinglingshenhe(data) {
  return request({
    url: "/order/water/card/reset/company/check",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}


export function cardClearoneCheck(data) {
  return request({
    url: "/order/water/card/reset/get/company/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}


// 水卡清零列表
export function cardClearZeroList(data) {
  return request({
    url:
      "/order/water/card/reset/get/company/list?pageNum=" +
      data.pageNum +
      "&pageSize=" +
      data.pageSize,

    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 水卡清零详情
export function cardClearZeroDetail(data) {
  return request({
    url: "/order/water/card/reset/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 水卡清零统计
export function cardClearZeroStat(data) {
  return request({
    url: "/order/water/card/reset/statistics",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 水卡列表统计
export function cardListStat(data) {
  return request({
    url: "/user/card/count/num",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 水卡列表统计
export function cardHuiFuListStat(data) {
  return request({
    url: "/order/water/card/reset/restore/clear/all/restore/sta?pageNum=" +
      data.pageNum +
      "&pageSize=" +
      data.pageSize,
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}
